exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_infoTable_ps20XVHhyfvNiXhh28AgF {\n  display: table;\n}\n.IA_infoTableRow_QTGxEroltpiV4xQawDB50 a{\n  text-decoration: none;\n}\n.IA_infoTableRow_QTGxEroltpiV4xQawDB50 a:hover{\n  text-decoration: underline;\n}\n.IA_infoTableRow_QTGxEroltpiV4xQawDB50 {\n  display: table-row;\n  height: 22px;\n  width: auto;\n}\n.IA_birthdayContainer_39_JhnCYarzKAuAIYK5Mil{\n  width: 100%;\n  display: inline-block;\n} \n.IA_birthdayList_4q5CF8FfLQuhLDB0PuSFA {\n  display: inline-block;\n}\n.IA_infoTableText_uZVCxQ4gNiNgSTuWTsjnR{\nfont-weight: 100;\n}", ""]);

// Exports
exports.locals = {
	"IA_infoTable": "IA_infoTable_ps20XVHhyfvNiXhh28AgF",
	"IA_infoTableRow": "IA_infoTableRow_QTGxEroltpiV4xQawDB50",
	"IA_birthdayContainer": "IA_birthdayContainer_39_JhnCYarzKAuAIYK5Mil",
	"IA_birthdayList": "IA_birthdayList_4q5CF8FfLQuhLDB0PuSFA",
	"IA_infoTableText": "IA_infoTableText_uZVCxQ4gNiNgSTuWTsjnR"
};